import { get } from "lodash";
import React, { FC } from "react";
import { styles as TextStyles } from "~/components/Text";
import { Identifiers } from "~/constants/enum";
import useCmsBlocks from "~/hooks/useCmsBlocks";
import { replaceClassNames } from "~/utils/converters";

interface FollowUsProps {
  data?: any;
}

const FollowUs: FC<FollowUsProps> = ({ data }) => {
  const { cmsBlocks } = useCmsBlocks(!data ? [Identifiers.FollowUs] : []);
  const content = data
    ? get(data, "content", null)
    : get(cmsBlocks, [Identifiers.FollowUs, "content"], null);

  const compileStyle = {
    Text: TextStyles,
  };

  return (
    !!content && (
      <div
        suppressHydrationWarning
        dangerouslySetInnerHTML={{
          __html: replaceClassNames(content, compileStyle),
        }}
      />
    )
  );
};

export default FollowUs;
